// Bilingual dictionary (EN / HI) for Biomass Zone
export const DICT = {
  EN: {
    brand: "Biomass Zone",
    nav_home: "Home",
    nav_we_serve: "We Serve",
    nav_solutions: "Solutions",
    nav_network: "Network",
    nav_marketplace: "Visit Marketplace",
    nav_downloads: "Downloads",
    nav_language: "Language",
    nav_admin: "Admin",
    contact_us: "Contact Us",
    call_support: "Call Support",
    post_req: "Post Requirement",
    sale_now: "Sale Now",
    login: "Login / Register",
    admin_btn: "View Admin Dashboard",

    hero_kicker: "India's Trusted Green Energy Biomass Marketplace",
    hero_title_1: "Biomass Products",
    hero_title_2: "Green Energy Marketplace",
    hero_desc:
      "Biomass Zone connects farmers, manufacturers, industrial buyers and transporters on one verified network — so pellets, briquettes and residue move faster from field to furnace.",
    hero_cta_primary: "Post Requirement",
    hero_cta_secondary: "Sale Now",

    stats_states: "States",
    stats_partners: "Verified partners",
    stats_support: "Support",

    sectors_kicker: "Active trade sectors",
    sectors_title: "Choose the role that fits you",
    sectors_desc:
      "Choose your role, fill the quick form, and connect instantly.",

    why_kicker: "Why Biomass Zone",
    why_title: "Built for India's biomass supply chain",
    why_1_t: "Verified partners",
    why_1_d: "GSTIN checks, references and site history — every counterparty is vetted before match.",
    why_2_t: "Faster deals",
    why_2_d: "Real-time matching + WhatsApp updates. Less chasing, more closing.",
    why_3_t: "Pan-India network",
    why_3_d: "Active nodes across 28 states — from Punjab paddy belts to Tamil Nadu boilers.",

    form_title: "Register your interest",
    form_name: "Full Name",
    form_phone: "Mobile Number",
    form_location: "City / State",
    form_email: "Email (optional)",
    form_notes: "Additional notes",
    form_submit: "Verify & Submit",
    form_sending: "Submitting…",
    form_success: "Submission received. We'll be in touch shortly.",
    role_specific: "Role-specific details",

    footer_tagline: "Making biomass trade transparent, verified and fast — for every stakeholder.",
    footer_rights: "All rights reserved.",
  },
  HI: {
    brand: "बायोमास ज़ोन",
    nav_home: "होम",
    nav_we_serve: "हम सर्व करते हैं",
    nav_solutions: "सॉल्यूशंस",
    nav_network: "नेटवर्क",
    nav_marketplace: "मार्केटप्लेस",
    nav_downloads: "डाउनलोड्स",
    nav_language: "भाषा",
    nav_admin: "एडमिन",
    contact_us: "संपर्क करें",
    call_support: "कॉल सपोर्ट",
    post_req: "मांग पोस्ट करें",
    sale_now: "अभी बेचें",
    login: "लॉगिन / पंजीकरण",
    admin_btn: "एडमिन डैशबोर्ड देखें",

    hero_kicker: "भारत का भरोसेमंद ग्रीन एनर्जी बायोमास मार्केटप्लेस",
    hero_title_1: "बायोमास प्रोडक्ट्स",
    hero_title_2: "ग्रीन एनर्जी मार्केटप्लेस",
    hero_desc:
      "बायोमास ज़ोन किसानों, निर्माताओं, औद्योगिक खरीदारों और ट्रांसपोर्टरों को एक वेरिफाइड नेटवर्क पर जोड़ता है — ताकि पेलेट्स, ब्रिकेट्स और अवशेष खेत से भट्टी तक तेज़ी से पहुँच सकें।",
    hero_cta_primary: "मांग पोस्ट करें",
    hero_cta_secondary: "अभी बेचें",

    stats_states: "राज्य",
    stats_partners: "सत्यापित पार्टनर्स",
    stats_support: "सहायता",

    sectors_kicker: "सक्रिय व्यापार क्षेत्र",
    sectors_title: "अपनी भूमिका चुनें",
    sectors_desc:
      "अपनी भूमिका चुनें, त्वरित फॉर्म भरें, और तुरंत जुड़ें।",

    why_kicker: "बायोमास ज़ोन क्यों",
    why_title: "भारत की बायोमास सप्लाई चेन के लिए बना",
    why_1_t: "वेरिफाइड पार्टनर्स",
    why_1_d: "GSTIN जाँच, संदर्भ और साइट इतिहास — मिलान से पहले हर पक्ष सत्यापित।",
    why_2_t: "तेज़ डील्स",
    why_2_d: "रीयल-टाइम मैचिंग + WhatsApp अपडेट्स। कम पीछा, ज़्यादा क्लोज़िंग।",
    why_3_t: "पैन-इंडिया नेटवर्क",
    why_3_d: "28 राज्यों में सक्रिय — पंजाब के पराली बेल्ट से तमिलनाडु के बॉयलर तक।",

    form_title: "अपनी रुचि दर्ज करें",
    form_name: "पूरा नाम",
    form_phone: "मोबाइल नंबर",
    form_location: "शहर / राज्य",
    form_email: "ईमेल (वैकल्पिक)",
    form_notes: "अतिरिक्त विवरण",
    form_submit: "सत्यापित करें और भेजें",
    form_sending: "भेजा जा रहा है…",
    form_success: "आपकी रिक्वेस्ट प्राप्त हो गई है। हम जल्द ही संपर्क करेंगे।",
    role_specific: "भूमिका-विशिष्ट विवरण",

    footer_tagline:
      "हर स्टेकहोल्डर के लिए पारदर्शी, सत्यापित और तेज़ बायोमास व्यापार।",
    footer_rights: "सर्वाधिकार सुरक्षित।",
  },
};

export const LANGS = [
  { code: "EN", label: "EN · English" },
  { code: "HI", label: "HI · हिन्दी" },
];

export const WHATSAPP_ADMIN = "919812498875";
